import OneIdWeb from '@datafe/oneid-web-sdk'
import { getInWindowsApp } from '@RootCommon/utils'

const isInWindowsApp = getInWindowsApp()

const initOneIdWeb = async () => {
  let webId = ''
  if (isInWindowsApp) {
    webId = await window.electronAPI.oneIdAPI.getAsyncWebID()
  } else {
    webId = await OneIdWeb.getAsyncWebID()
  }
  window.getWebId = () => webId
}

export { initOneIdWeb }